"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isClient = _interopRequireDefault(require("@argo/utils/isClient"));
var _react = require("react");
var _default = function _default(props, callback, _ref) {
  var callOnMount = _ref.callOnMount;
  if ((0, _isClient["default"])() && typeof callback === 'function') {
    (0, _react.useEffect)(function () {
      if (callOnMount) {
        callback();
      }
      window.addEventListener('resize', callback);
      return function () {
        window.removeEventListener('resize', callback);
      };
    }, props);
  }
};
exports["default"] = _default;